import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Modal from "common/components/Modal/Modal"
import { Button } from "primereact/button"
import { useState } from "react"
import MapComponent from "../MapComponent"

const MapExpanded = ({ postalCode, address }: $TSMigrationFixMe) => {
  const [expandMap, setExpandMap] = useState(false)

  return (
    <>
      <Button
        type='button'
        className='map-expand-button'
        onClick={() => setExpandMap(true)}
      >
        {/* @ts-expect-error TS(2322): Type '"fa-expand"' is not assignable to type 'Icon... */}
        <FontAwesomeIcon icon={["fal", "fa-expand"]} />
      </Button>
      <Modal
        className='expand-map-modal'
        header={address}
        visible={expandMap}
        onHide={() => setExpandMap(false)}
      >
        <MapComponent
          postalCode={postalCode}
          address={address}
          className='map_display__expanded'
        />
      </Modal>
    </>
  )
}

export default MapExpanded
